export default function (context, val) {
    context.commit('set_form', {
        ContragentType: val,
    });
    if(val>2&&(context.state.form.CategoryId===2||context.state.system.type!=='pay')) context.dispatch('change_CategoryId',1);
    if (context.getters.options_contragents.length) context.dispatch('change_ContragentID', context.getters.options_contragents[0].value);
    else{
        context.commit('set_form',{
            ContragentID: null,
            ContragentName: '',
            PartnerLegalEntityId: null,
        });
    }
    context.dispatch('agreement_comment');
    context.dispatch('agreement_sums');
}
